<template>
    <section id="vue-location">
        <place
            event-name="The Ceremony"
            time="September 8, 2018 - 5pm"
            location-name="Shattering Silence Memorial"
            address="E Court Ave"
            city="Des Moines"
            state="IA"
            zip="50319"
            map-source="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2984.116356476465!2d-93.60541458479561!3d41.58836547924622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87ee99b5b9035cf5%3A0x5ccb9a9a4b1c6740!2sShattering+Silence%2C+E+Court+Ave%2C+Des+Moines%2C+IA+50319!5e0!3m2!1sen!2sus!4v1514072862854"
            directions-link="https://www.google.com/maps/place/Shattering+Silence,+E+Court+Ave,+Des+Moines,+IA+50319/@41.5883655,-93.6054146,17z/data=!3m1!4b1!4m5!3m4!1s0x87ee99b5b9035cf5:0x5ccb9a9a4b1c6740!8m2!3d41.5883655!4d-93.6032259"
            instructions="parking directly east of the Iowa Court of Appeals"
            image="images/shattering-silence.jpg"
        />
        <place
            event-name="The Reception"
            time="Immediately following nuptials"
            location-name="Iowa Taproom - Marquette Room"
            address="215 East 3rd Street #100"
            city="Des Moines"
            state="IA"
            zip="50309"
            map-source="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2984.1576279489627!2d-93.61520388479566!3d41.58747257924628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87ee99ada282bdb9%3A0x62bf777011060dce!2sThe+Iowa+Taproom!5e0!3m2!1sen!2sus!4v1514073078646"
            directions-link="https://www.google.com/maps/place/The+Iowa+Taproom/@41.5874726,-93.6152039,17z/data=!3m1!4b1!4m5!3m4!1s0x87ee99ada282bdb9:0x62bf777011060dce!8m2!3d41.5874726!4d-93.6130152"
            instructions="parking immediately east of 4th street"
            image="images/taproom.jpg"
        />
    </section>
</template>

<script>
import Place from '../components/place.vue';

export default {
    name: 'splash-view',
    components: {
        'place': Place
    },
    data: () => ({
        message: 'we\'re getting married!',
        buttonText: 'RSVP'
    })
};
</script>


// WEBPACK FOOTER //
// src/views/location.vue?05fc3bc0